<template>
  <div class="main-wrapper">
    <layout-header />

    <div class="content container">
      <div class="px-3">
        <div class="row">
          <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
            <div class="stickyside mb-3" style="top: 120px;">
              <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
            </div>
          </div>

          <div class="col-12 col-xl-9">
            <div class="d-sm-flex d-block justify-content-between align-items-center border-bottom mb-4">
              <h2>Détails Match</h2>
              <a href="/my/admin/matches" class="btn btn-sm btn-light border">Retour</a>
            </div>

            <div v-if="!match.id" class="text-center text-muted">Chargement...</div>

            <div v-else>
              <div class="d-flex justify-content-around align-items-top py-4">
                <div class="mt-3 text-center w-100" style="max-width: 33%;">
                  <figure class="bg-white rounded-xl p-3 mb-2 border mx-auto" style="width: fit-content;">
                    <img :src="match.team_a?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                  </figure>
                  <span class="d-block mb-3">{{ match.team_a?.name }}</span>
                </div>

                <div class="mx-2 d-flex flex-column justify-content-start align-items-center">
                  <span class="text-muted text-center mb-3">{{ formatDateTime(match.booking?.start_time).datetime }}</span>
                  <span class="font-weight-bold d-flex align-items-center">
                    <input type="number" class="form-control form-control-sm d-inline-block" style="width: 70px;" min="0" v-model.number="form.score_a"/>
                    <b class="h1 mx-1">-</b>
                    <input type="number" class="form-control form-control-sm d-inline-block" style="width: 70px;" min="0" v-model.number="form.score_b"/>
                  </span>

                  <div v-if="showLiveMinute" class="live-minute-badge my-3">{{ liveMinute }}'</div>

                  <div v-else class="d-flex align-items-center mt-2">
                    <span class="badge badge-pill text-xs py-1 px-2" :class="statuses[match.status]?.class || 'bg-light'">
                      {{ statuses[match.status]?.label || match.status }}
                    </span>
                  </div>

                  <div class="d-flex flex-column mt-3">
                    <button class="btn btn-sm btn-primary text-xs" @click="forceScore">Forcer le score</button>
                  </div>
                </div>

                <div class="mt-3 text-center w-100" style="max-width: 33%;">
                  <figure class="bg-white rounded-xl p-3 mb-2 border mx-auto" style="width: fit-content;">
                    <img :src="match.team_b?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                  </figure>
                  <span class="d-block mb-3">{{ match.team_b?.name }}</span>
                </div>
              </div>

              <div class="tab-content mb-5 pb-3">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified mb-4" style="border-bottom: 1px solid #dee2e6">
                  <li class="nav-item" v-if="showResumeTab">
                    <a class="nav-link" :class="{ active: activeTab === 'summary' }" @click="activeTab='summary'" href="javascript:void(0)">Resumé</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'general' }" @click="activeTab='general'" href="javascript:void(0)">Informations</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'formation' }" @click="activeTab='formation'" href="javascript:void(0)">Compositions</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'h2h' }" @click="activeTab='h2h'" href="javascript:void(0)">Tête-à-tête</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'actions' }" @click="activeTab='actions'" href="javascript:void(0)">Actions</a>
                  </li>
                </ul>

                <div v-if="activeTab === 'summary' && showResumeTab" class="tab-pane fade show active">
                  <div>
                    <div v-if="orderedActions.length === 0" class="text-center text-sm text-muted py-4">Aucune action.</div>
                    <div v-else class="border rounded-lg bg-white px-3 py-2">
                      <div
                        v-for="action in orderedActions"
                        :key="action.id"
                        class="summary-event border-bottom py-2"
                        :class="action.team_id === match.team_b_id ? 'summary-event-right' : 'summary-event-left'"
                      >
                        <div class="summary-event-minute text-muted text-xs">{{ action.minute ? `${action.minute}'` : '-' }}</div>
                        <div class="summary-event-marker">
                          <span class="action-marker" :class="actionTypeTone(action.action_type)">
                            <span class="material-symbols-outlined action-marker-icon">{{ actionTypeIcon(action.action_type) }}</span>
                          </span>
                        </div>
                        <div class="summary-event-copy">
                          <div class="text-sm font-weight-medium">{{ actionTypeLabel(action.action_type) }}</div>
                          <div class="text-xs text-muted">{{ action.player?.name || '-' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="activeTab === 'general'" class="tab-pane fade show active">
                  <table class="table table-striped table-borderless text-sm">
                    <tbody>
                      <tr>
                        <td>Terrain</td>
                        <td class="text-right">
                          <b>Terrain {{ match.booking?.slot?.facility?.name || '-' }}</b>
                          <span class="ml-1">({{ match.booking?.slot?.facility?.establishment?.business_name || '-' }})</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td class="text-right">{{ formatDateTime(match.booking?.start_time).date }}</td>
                      </tr>
                      <tr>
                        <td>Heure</td>
                        <td class="text-right">{{ formatDateTime(match.booking?.start_time).time }} - {{ formatDateTime(match.booking?.end_time).time }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="activeTab === 'formation'" class="tab-pane fade show active">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="border rounded-lg p-3 h-100">
                        <h6 class="mb-2">{{ match.team_a?.name }} - Titulaires</h6>
                        <table class="table table-sm table-borderless mb-0 text-sm">
                          <tbody>
                            <tr v-for="p in startersTeamA" :key="p.key">
                              <td class="pl-0">{{ p.player_name }}</td>
                            </tr>
                            <tr v-if="startersTeamA.length === 0">
                              <td class="pl-0 text-muted">Aucun titulaire</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="border rounded-lg p-3 h-100">
                        <h6 class="mb-2">{{ match.team_b?.name }} - Titulaires</h6>
                        <table class="table table-sm table-borderless mb-0 text-sm">
                          <tbody>
                            <tr v-for="p in startersTeamB" :key="p.key">
                              <td class="pl-0">{{ p.player_name }}</td>
                            </tr>
                            <tr v-if="startersTeamB.length === 0">
                              <td class="pl-0 text-muted">Aucun titulaire</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="activeTab === 'h2h'" class="tab-pane fade show active">
                  <div class="row">
                    <div class="col-md-6">
                      <h6 class="text-sm font-weight-bold">Derniers matchs - {{ match.team_a?.name || 'Équipe A' }}</h6>
                      <ul class="list-unstyled text-sm">
                        <li v-if="recentMatchesTeamA.length === 0" class="text-muted">Aucun match.</li>
                        <li v-for="m in recentMatchesTeamA" :key="m.id" class="py-2 border-bottom">
                          <div class="d-flex justify-content-between">
                            <div>
                              <strong class="mr-1">{{ m.team_a?.name || 'N/A' }}</strong>
                              -
                              <strong class="ml-1">{{ m.team_b?.name || 'N/A' }}</strong>
                            </div>
                            <div>{{ (m.status === 'completed') ? (m.score_a + ' - ' + m.score_b) : '-' }}</div>
                          </div>
                          <div class="text-muted text-xs">{{ formatDateTime(m.booking?.start_time).date }} {{ formatDateTime(m.booking?.start_time).time }}</div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <h6 class="text-sm font-weight-bold">Derniers matchs - {{ match.team_b?.name || 'Équipe B' }}</h6>
                      <ul class="list-unstyled text-sm">
                        <li v-if="recentMatchesTeamB.length === 0" class="text-muted">Aucun match.</li>
                        <li v-for="m in recentMatchesTeamB" :key="m.id" class="py-2 border-bottom">
                          <div class="d-flex justify-content-between">
                            <div>
                              <strong class="mr-1">{{ m.team_a?.name || 'N/A' }}</strong>
                              -
                              <strong class="ml-1">{{ m.team_b?.name || 'N/A' }}</strong>
                            </div>
                            <div>{{ (m.status === 'completed') ? (m.score_a + ' - ' + m.score_b) : '-' }}</div>
                          </div>
                          <div class="text-muted text-xs">{{ formatDateTime(m.booking?.start_time).date }} {{ formatDateTime(m.booking?.start_time).time }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-if="activeTab === 'actions'" class="tab-pane fade show active">
                  <div class="row">
                    <div class="col-md-4 order-1 order-md-1 mb-3 mb-md-0">
                      <div class="border rounded-lg p-3 bg-light">
                        <h6 class="mb-3">{{ editingActionId ? 'Modifier une action' : 'Ajouter une action' }}</h6>
                        <label class="text-xs mb-1">Équipe</label>
                        <select v-model="newAction.team_id" @change="onActionTeamChange" class="form-control form-control-sm mb-2 custom-select">
                          <option :value="match.team_a_id">{{ match.team_a?.name }}</option>
                          <option :value="match.team_b_id">{{ match.team_b?.name }}</option>
                        </select>
                        <label class="text-xs mb-1">Joueur (optionnel)</label>
                        <select v-model="newAction.player_id" class="form-control form-control-sm mb-2 custom-select">
                          <option value="">Sans joueur</option>
                          <option v-for="p in actionTeamPlayers" :key="p.key" :value="p.player_id || ''">
                            {{ p.player_name }}
                          </option>
                        </select>
                        <label class="text-xs mb-1">Type</label>
                        <select v-model="newAction.action_type" class="form-control form-control-sm mb-2 custom-select">
                          <option value="goal">But</option>
                          <option value="yellow_card">Carton jaune</option>
                          <option value="red_card">Carton rouge</option>
                        </select>
                        <label class="text-xs mb-1">Minute</label>
                        <input class="form-control form-control-sm mb-2" v-model.number="newAction.minute" type="number" min="1" max="150" />
                        <div class="d-flex gap-2">
                          <button class="btn btn-sm btn-success flex-grow-1" @click="saveAction">{{ editingActionId ? 'Mettre à jour' : 'Ajouter' }}</button>
                          <button v-if="editingActionId" class="btn btn-sm btn-light border" @click="cancelEditAction">Annuler</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 order-2 order-md-2">
                      <div class="border rounded-lg bg-white action-table-wrap">
                        <div class="table-responsive mb-0">
                          <table class="table table-striped table-borderless text-sm action-table mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th class="action-col-minute">Minute</th>
                                <th class="action-col-type">Type</th>
                                <th>Joueur</th>
                                <th>Équipe</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="actions.length === 0">
                                <td colspan="5" class="text-center text-muted">Aucune action enregistrée.</td>
                              </tr>
                              <tr v-for="a in orderedActions" :key="a.id">
                                <td class="action-col-minute">{{ a.minute ? `${a.minute}'` : '-' }}</td>
                                <td class="action-col-type">{{ actionTypeLabel(a.action_type) }}</td>
                                <td>{{ a.player?.name || a.player_id || 'N.A.' }}</td>
                                <td>{{ teamName(a.team_id) }}</td>
                                <td class="text-right text-nowrap">
                                  <button class="btn btn-sm btn-outline-primary icon-action-btn mr-1" @click="startEditAction(a)" title="Modifier" aria-label="Modifier">
                                    <span class="material-symbols-outlined">edit</span>
                                  </button>
                                  <button class="btn btn-sm btn-danger icon-action-btn" @click="deleteAction(a)" title="Supprimer" aria-label="Supprimer">
                                    <span class="material-symbols-outlined">delete</span>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <layout-footer />
  </div>
</template>

<script>
import moment from 'moment'
import { api } from '@/store'
import defaultTeamLogoPath from '@/assets/img/default-team-logo.png'
import VendorSidebar from '@/components/Vendors/Partials/Sidebar'

export default {
  components: {
    'vendor-sidebar': VendorSidebar,
  },
  props: ['id'],
  computed: {
    liveBooking() {
      return this.match.booking || null
    },
    liveMinute() {
      const booking = this.liveBooking
      if (!booking?.start_time || !booking?.end_time) return null

      const now = new Date(this.now)
      const start = new Date(booking.start_time)
      const end = new Date(booking.end_time)

      if (Number.isNaN(now.getTime()) || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null
      if (now < start || now > end) return null

      const minute = Math.floor((now - start) / 60000) + 1
      return minute > 0 ? minute : 1
    },
    showLiveMinute() {
      return this.liveMinute !== null
    },
    orderedActions() {
      return [...this.actions].sort((a, b) => (a.minute || 0) - (b.minute || 0))
    },
    summaryTeamAActions() {
      return this.orderedActions.filter(action => action.team_id === this.match.team_a_id)
    },
    summaryTeamBActions() {
      return this.orderedActions.filter(action => action.team_id === this.match.team_b_id)
    },
    showResumeTab() {
      return this.hasMatchStarted(this.match)
    },
    startersTeamA() {
      return this.getTeamStarters(this.match.team_a_id)
    },
    startersTeamB() {
      return this.getTeamStarters(this.match.team_b_id)
    },
    actionTeamPlayers() {
      return this.getTeamStarters(this.newAction.team_id)
    },
    matchCapacitySlots() {
      return this.getMatchCapacity(this.match) || 0
    },
  },
  data() {
    return {
      activeTab: 'general',
      now: Date.now(),
      liveTimer: null,
      defaultTeamLogoPath,
      match: {},
          recentMatchesTeamA: [],
          recentMatchesTeamB: [],
      actions: [],
      editingActionId: null,
      possibleFormations: [],
      formationPositions: ['goalkeeper', 'defender', 'midfielder', 'forward'],
      form: { score_a: 0, score_b: 0 },
      newAction: { action_type: 'goal', player_id: '', team_id: null, minute: null },
      statuses: {
        challenged: { label: 'en cours', class: 'bg-warning-light' },
        scheduled: { label: 'à venir', class: 'bg-primary-light' },
        completed: { label: 'terminé', class: 'bg-success-light' },
        cancelled: { label: 'annulé', class: 'bg-danger text-white' },
      },
    }
  },
  mounted() {
    this.getMatch()
    this.startLiveClock()
  },
  beforeUnmount() {
    if (this.liveTimer) {
      clearInterval(this.liveTimer)
      this.liveTimer = null
    }
  },
  methods: {
    formatDateTime(datetimeString) {
      if (!datetimeString) return { date: '-', time: '-', datetime: '-' }
      const date = new Date(datetimeString)
      const formattedDate = date.toISOString().split('T')[0]
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return {
        date: formattedDate,
        time: `${hours}:${minutes}`,
        datetime: `${formattedDate} ${hours}:${minutes}`,
      }
    },
    teamName(teamId) {
      if (teamId === this.match.team_a_id) return this.match.team_a?.name || 'Equipe A'
      if (teamId === this.match.team_b_id) return this.match.team_b?.name || 'Equipe B'
      return 'N.A.'
    },
    actionTypeLabel(actionType) {
      if (actionType === 'goal') return 'But'
      if (actionType === 'yellow_card') return 'Carton jaune'
      if (actionType === 'red_card') return 'Carton rouge'
      return actionType || 'Action'
    },
    actionTypeIcon(actionType) {
      if (actionType === 'goal') return 'sports_soccer'
      return 'crop_square'
    },
    actionTypeTone(actionType) {
      if (actionType === 'goal') return 'tone-goal'
      if (actionType === 'yellow_card') return 'tone-yellow'
      if (actionType === 'red_card') return 'tone-red'
      return 'tone-neutral'
    },
    hasMatchStarted(match) {
      const startTime = match?.booking?.start_time
      if (!startTime) return false
      return this.formatDateTime(startTime).datetime <= moment().format('YYYY-MM-DD HH:mm')
    },
    getMatch() {
      const matchId = this.id || this.$route.params.id
      api.get(`/private/matches/${matchId}`).then(res => {
        const match = res.data || {}
        const facilityCapacity = this.getMatchCapacity(match)
        if (facilityCapacity) {
          this.possibleFormations = this.generateFormations(facilityCapacity)
        } else {
          this.possibleFormations = []
        }

        if (facilityCapacity && this.possibleFormations.length) {
          match.team_a_formation ||= (parseInt(match.team_a?.format?.split('v')[0]) === facilityCapacity) ? match.team_a?.formation : this.possibleFormations[0]
          match.team_b_formation ||= (parseInt(match.team_b?.format?.split('v')[0]) === facilityCapacity) ? match.team_b?.formation : this.possibleFormations[0]
        } else {
          match.team_a_formation ||= match.team_a?.formation || null
          match.team_b_formation ||= match.team_b?.formation || null
        }

        let teamALineups = (match.lineups || []).filter(l => l.team_id === match.team_a_id)
        let teamBLineups = (match.lineups || []).filter(l => l.team_id === match.team_b_id)

        if (!match.lineups || !match.lineups.length) {
          match.lineups = [
            ...this.initTeamLineup(match.team_a, match.team_a_formation),
            ...this.initTeamLineup(match.team_b, match.team_b_formation)
          ]
        }

        if (this.lineupToInit(teamALineups)) {
          teamALineups = this.initTeamLineup(match.team_a, match.team_a_formation, teamALineups)
        }
        if (this.lineupToInit(teamBLineups)) {
          teamBLineups = this.initTeamLineup(match.team_b, match.team_b_formation, teamBLineups)
        }

        match.lineups = [...teamALineups, ...teamBLineups]
        this.match = match
        this.loadHeadToHead()
        this.form.score_a = match.score_a || 0
        this.form.score_b = match.score_b || 0
        this.newAction.team_id = match.team_a_id
        this.loadActions()
        if (this.showResumeTab) {
          this.activeTab = 'summary'
        }
      })
    },
    loadActions() {
      if (!this.match?.id) return
      api.get(`/private/matches/${this.match.id}/actions`).then(res => {
        this.actions = res.data || []
      })
    },
    async loadHeadToHead() {
      if (!this.match?.id) return
      try {
        const res = await api.get('/private/matches')
        const all = res.data || []
        const teamAId = this.match.team_a_id
        const teamBId = this.match.team_b_id
        const forTeam = id => all
          .filter(m => m.team_a_id === id || m.team_b_id === id)
          .sort((a, b) => {
            const ta = (a.booking && a.booking.start_time) ? new Date(a.booking.start_time) : new Date(0)
            const tb = (b.booking && b.booking.start_time) ? new Date(b.booking.start_time) : new Date(0)
            return tb - ta
          })
          .slice(0, 5)
        this.recentMatchesTeamA = forTeam(teamAId)
        this.recentMatchesTeamB = forTeam(teamBId)
      } catch (e) {
        this.recentMatchesTeamA = []
        this.recentMatchesTeamB = []
      }
    },
    getTeamStarters(teamId) {
      if (!teamId || !Array.isArray(this.match?.lineups)) return []
      const starters = this.match.lineups.filter(l => l.team_id === teamId && l.role === 'starting')
      const source = starters.length ? starters : this.match.lineups.filter(l => l.team_id === teamId)
      const seen = new Set()
      return source
        .map(p => ({
          key: p.player_id || p.player_name,
          player_id: p.player_id || '',
          player_name: p.player_name || 'Joueur',
        }))
        .filter(p => {
          if (!p.key || seen.has(p.key)) return false
          seen.add(p.key)
          return true
        })
    },
    lineupToInit(lineup) {
      const lineupGuests = lineup.filter(l => l.is_guest)
      const lineupSubstitutes = lineup.filter(l => l.role === 'substitute')
      return lineupSubstitutes.length === lineup.length || lineupGuests.length === lineup.length
    },
    initTeamLineup(team, formation, teamGuests = []) {
      if (!team || !formation) return []
      const slots = this.buildFormationMap(formation)
      const orderedPositions = this.formationPositions
      let members = (team.memberships || [])
        .filter(m => m.status === 'accepted')
        .map(m => ({
          id: null,
          match_id: this.id,
          team_id: team.id,
          player_id: m.player_id,
          player_name: m.player?.name || '',
          is_guest: false,
          role: m.role === 'starting' ? 'starting' : 'substitute',
          position: m.lineup_position || null,
          status: 'confirmed'
        }))

      members = [...members, ...teamGuests]
      const starters = []
      const used = new Set()

      orderedPositions.forEach(position => {
        const max = slots[position] || 0
        if (!max) return
        const candidates = members.filter(m => m.role === 'starting' && m.position === position && !used.has(m.player_id))
        candidates.slice(0, max).forEach(p => {
          starters.push(p)
          used.add(p.player_id)
        })
      })

      orderedPositions.forEach(position => {
        const filled = starters.filter(s => s.position === position).length
        const remaining = (slots[position] || 0) - filled
        if (remaining <= 0) return
        const candidates = members.filter(m => m.role === 'starting' && !used.has(m.player_id))
        candidates.slice(0, remaining).forEach(p => {
          p.position = position
          starters.push(p)
          used.add(p.player_id)
        })
      })

      orderedPositions.forEach(position => {
        const filled = starters.filter(s => s.position === position).length
        const remaining = (slots[position] || 0) - filled
        if (remaining <= 0) return
        const candidates = members.filter(m => m.role === 'substitute' && !used.has(m.player_id))
        candidates.slice(0, remaining).forEach(p => {
          p.role = 'starting'
          p.position = position
          starters.push(p)
          used.add(p.player_id)
        })
      })

      members.forEach(m => {
        if (m.role === 'starting' && !used.has(m.player_id)) {
          m.role = 'substitute'
          m.position = null
        }
      })

      return members
    },
    buildFormationMap(formation) {
      if (!formation) return { goalkeeper: 1, defender: 0, midfielder: 0, forward: 0 }
      const parts = formation.split('-').map(Number)
      return {
        goalkeeper: 1,
        defender: parts[0] || 0,
        midfielder: parts[1] || 0,
        forward: parts[2] || 0,
      }
    },
    generateFormations(totalPlayers) {
      const outfield = totalPlayers - 1
      const formations = []

      for (let d = 1; d <= outfield - 2; d++) {
        for (let m = 1; m <= outfield - d - 1; m++) {
          const f = outfield - d - m
          if (f >= 1) formations.push(`${d}-${m}-${f}`)
        }
      }
      return formations
    },
    getReferenceBooking(match) {
      if (match?.booking) return match.booking
      const suggestions = match?.suggestions || []
      const selected = suggestions.find(s => s.status === 'accepted') || suggestions.find(s => s.status === 'pending') || suggestions[0]
      return selected?.booking || null
    },
    getMatchCapacity(match) {
      const capacity = this.getReferenceBooking(match)?.slot?.facility?.capacity
      if (!capacity) return null
      return capacity / 2
    },
    onActionTeamChange() {
      this.newAction.player_id = ''
    },
    startEditAction(action) {
      this.editingActionId = action.id
      this.newAction = {
        action_type: action.action_type || 'goal',
        player_id: action.player_id || '',
        team_id: action.team_id || this.match.team_a_id,
        minute: action.minute,
      }
      this.activeTab = 'actions'
    },
    cancelEditAction() {
      this.editingActionId = null
      this.newAction = { action_type: 'goal', player_id: '', team_id: this.match.team_a_id, minute: null }
    },
    forceScore() {
      api.post(`/private/matches/${this.match.id}/force_score`, {
        score_a: this.form.score_a,
        score_b: this.form.score_b,
      }).then(() => {
        this.getMatch()
      }).catch(err => {
        alert(err.response?.data?.detail || 'Erreur lors du forçage du score')
      })
    },
    saveAction() {
      const payload = {
        ...this.newAction,
        player_id: this.newAction.player_id || null,
      }
      const request = this.editingActionId
        ? api.patch(`/private/matches/${this.match.id}/actions/${this.editingActionId}`, payload)
        : api.post(`/private/matches/${this.match.id}/actions`, payload)

      request.then(() => {
        this.cancelEditAction()
        this.loadActions()
      }).catch(err => {
        alert(err.response?.data?.detail || (this.editingActionId ? 'Erreur lors de la mise à jour de l\'action' : 'Erreur lors de l\'ajout de l\'action'))
      })
    },
    deleteAction(action) {
      api.delete(`/private/matches/${this.match.id}/actions/${action.id}`).then(() => {
        this.loadActions()
      }).catch(err => {
        alert(err.response?.data?.detail || 'Erreur lors de la suppression de l\'action')
      })
    },
    startLiveClock() {
      this.now = Date.now()
      if (this.liveTimer) {
        clearInterval(this.liveTimer)
      }
      this.liveTimer = setInterval(() => {
        this.now = Date.now()
      }, 15000)
    },
  },
}
</script>

<style scoped>
.action-marker {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
}

.action-marker-icon {
  font-size: 14px !important;
  line-height: 1;
}

.summary-event {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.summary-event-left {
  flex-direction: row;
  text-align: left;
}

.summary-event-right {
  flex-direction: row-reverse;
  text-align: right;
}

.summary-event-minute {
  min-width: 42px;
  flex: 0 0 42px;
}

.summary-event-marker {
  flex: 0 0 22px;
}

.summary-event-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.action-table-wrap {
  overflow-x: auto;
}

.action-table {
  min-width: 720px;
}

.action-col-minute {
  width: 70px;
  white-space: nowrap;
}

.action-col-type {
  width: 120px;
  white-space: nowrap;
}

.icon-action-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-action-btn .material-symbols-outlined {
  font-size: 18px;
  line-height: 1;
}

.tone-goal {
  background: rgba(25, 135, 84, 0.12);
  color: #198754;
}

.tone-yellow {
  background: rgba(255, 193, 7, 0.16);
  color: #b58100;
}

.tone-red {
  background: rgba(220, 53, 69, 0.14);
  color: #dc3545;
}

.tone-neutral {
  background: rgba(108, 117, 125, 0.12);
  color: #6c757d;
}

.live-minute-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  color: #fff;
  font-weight: 700;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  background: #A61616;
  animation: livePulse 1.4s ease-in-out infinite;
}

@keyframes livePulse {
  0% {
    background: #A61616;
    box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
  }
  50% {
    background: #E63232;
    box-shadow: 0 0 12px 2px rgba(230, 50, 50, 0.45);
  }
  100% {
    background: #A61616;
    box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
  }
}
</style>
